import React, { Component } from 'react';
import {loadCsrf} from '../common/CsrfFetcher';
import { validateName } from '../helper/validateName';
import { validatePassword } from '../helper/validatePassword';
import scrollToElement from 'scroll-to-element';
import {FormError} from '../FormError';
import {FormErrors} from '../FormErrors';
import Loader from 'react-loader';
import {FormControl,FormGroup,ControlLabel,HelpBlock, Checkbox} from 'react-bootstrap';

class RegisterUserWithJoinCode extends Component {

    constructor(props) {
		super(props);
        const hostApiUrl = process.env.REACT_APP_HOST_API_URL;
		this.state = {
                csrfToken: '',
                csrfTokenHeaderName:'',
				showEnterUserInfoForm : false,
                firstName: {value:'', isValid: '', message:'', hasErrorFocus: false},
                lastName: {value:'', isValid: '', message:'', hasErrorFocus: false},
                email: {value:'', isValid: '', isAvailable:'', message:'', hasErrorFocus: false},
                password: {value:'', isValid: '', message:'', hasErrorFocus: false},
                newsletterSubscription: {value:true, isValid: '', message:''},
                eventsSubscription: {value:true, isValid: '', message:''},
                captcha: {value:'', isValid:'', message:'', image: hostApiUrl + '/developer/mvc/captcha/image?v='+ Date.now() },
                token: {value:''},
				genericFormLevelProblems: [],
                isCreateUserSubmitted: false
            }
        this.audioCaptcha = React.createRef();
        this.audioSrc = React.createRef();
	}

	componentDidMount() {
		loadCsrf(this.setCsrfState);
		this.validateToken();
	}


    setCsrfState = (csrfToken, csrfHeaderValue) => {
        var state = this.state;
        state.csrfToken = csrfToken;
        state.csrfTokenHeaderName = csrfHeaderValue;
        this.setState({
          state
        });
    }

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.value;
		const name = target.name;
        var state = this.state;

        if(name === 'newsletterSubscription' || name === 'eventsSubscription'){
            if(target.checked){
                state[name].value = true;
            }
            else{
                state[name].value = false;
            }
        }
        else{
            state[name].value = value;
        }
        this.setState(state,
                    () => { this.validateField(name, value) });
	}

    validateField = (fieldName, value) => {

      var state = this.state;
      state.genericFormLevelProblems = [];

      if(fieldName ==='firstName'){
        this.validateNameResponse(fieldName,value, state);
      }

      if(fieldName === 'lastName'){
          this.validateNameResponse(fieldName, value, state);
      }

      if(fieldName === 'password'){
          this.validatePasswordResponse(fieldName, value, state);
      }

      if(fieldName ==='captcha'){
          this.validateCaptcha(fieldName, value, state);
      }

      this.setState(state);
    }

    validateNameResponse = (fieldName, value, state) => {
        const validateNameData = validateName(fieldName, value, state)
        state[fieldName].isValid = validateNameData.isValid;
        state[fieldName].message = validateNameData.message;
    }

    validatePasswordResponse = (fieldName, value, state) => {
         const validatePasswordData = validatePassword(value, state);
         state[fieldName].isValid = validatePasswordData.isValid;
         state[fieldName].message = validatePasswordData.message;
     }

     validateCaptcha = (fieldName, value, state) => {
         const length = value.length;
         if( length < 1 ){
             state[fieldName].isValid = false;
             state[fieldName].message = "Error: Please enter the text in the captcha image";
         }
         else if (length > 5){
           state[fieldName].isValid = false;
           state[fieldName].message = "Error: Please enter the text in the captcha image";
         }
         else if (length >= 1 && length <= 5){
           state[fieldName].isValid = true;
           state[fieldName].message = "";
        }
     }

	validateToken = () => {

        const queryString = window.location.search;

        let allParams = new URLSearchParams(queryString);
        const token = allParams.get("token");
        console.log('token is ' + token);
        var apiUrl = process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/registerAndJoinOrg?token=' + token;

        var request =  {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        };

        fetch(apiUrl, request)
            .then(response => {
                if(response.ok){
                    console.log("it is ok!!!!");
                    return response.json();
                }

                if (!response.ok) {
                  console.log("response is not ok " + response.statusText  + " with status of : " + response.status);
                  if(response.status === 400 || response.status === 409){
                      return response.json();
                  }

                  throw new Error("Unknown Problem occurred : " + response.statusText);
                }

            })
			.then(json => {

				console.log('response from validateToken ' + json.errorCode);
                if(json.errorCode){
                    //we know we have an error
                    console.log("it failed and we got back JSON back with an errorCode: " + json.errorCode);
                    if(json.errorCode === "UserInIdentityProviderAndNotInPortalException"){
                        console.log("user exists in HALO but not here.  Allow them to continue");
                        for(let i =0; i<json.validationErrors.length; i++){
                            const rejectedValue = json.validationErrors[i].rejectedValue;
                            const field = json.validationErrors[i].field;
                            if(field === "email"){
                                this.setState({
                                    email: {value:rejectedValue},
                                    token: {value:token},
                                    showEnterUserInfoForm: true
                                });
                                return;
                            }
                        }
                        //if we get here, it means we didn't get an email, so can't continue.
                        window.location.href = process.env.REACT_APP_HOST_API_URL + '/developer/errorRedirect.jsp?errorKey=invalid.token';
                        this.setState({
                            showEnterUserInfoForm: false
                        })
                    }
                    else{
                        this.setState({
                            showEnterUserInfoForm: false
                        })

                        window.location.href = process.env.REACT_APP_HOST_API_URL + '/developer/errorRedirect.jsp?errorKey=invalid.token';
                    }
                }
                else{
                    console.log("it worked, we should get JSON back with an email address: " + json.email);
                    this.setState({
                        email: {value:json.email},
                        token: {value:token},
                        showEnterUserInfoForm: true
                    });

                }
			})
			.catch(error => {
				console.log('error trying to validate token : \n', error);
                this.setState({
                    showEnterUserInfoForm: false
                })
                window.location.href = process.env.REACT_APP_HOST_API_URL + '/developer/error.jsp';

				return Promise.reject()
			})
	}

    getValidationState(isValid){
  	if(isValid === '' || isValid == null){
        return null;
      }
      if(isValid){
        return 'success';
      }
      else{
        return 'error';
      }
    }


    playClip = () =>{
        const audioElement = this.audioCaptcha.current;
        audioElement.pause();
        audioElement.load();
        audioElement.play();
    };

    refreshCaptcha = () => {
        let captcha = this.state.captcha;
        captcha.image = process.env.REACT_APP_HOST_API_URL + '/developer/mvc/captcha/image?v='+ Date.now();
        this.setState({
                    captcha: captcha
             });
    };

	 handleFormSubmit = (event) => {
		 event.preventDefault();
//	 	if (this.validateForm()) {
//			this.setState({
//				showSubmitUpgradeOrgRequestModal: true
//		    });
//	 	}
		this.submitForm(event);
	 }

     handleValidationBeforeFormSubmit = (event) =>{
         var state = this.state;

         //rerun the validations to make the appropriate messages appear
         this.validateNameResponse('firstName', this.state.firstName.value, state);
         this.validateNameResponse('lastName', this.state.lastName.value, state);
         this.validatePasswordResponse('password', this.state.password.value, state);
         this.validateCaptcha('captcha', this.state.captcha.value, state);


         this.setState({state});

         const isValidToContinue = this.state.firstName.isValid &&
                                 this.state.lastName.isValid &&
                                 this.state.password.isValid &&
                                 this.state.captcha.isValid;

         if(!isValidToContinue){
             event.preventDefault();
             this.setState({
                           genericFormLevelProblems: ['Please correct the issues below before continuing']
                           });

         }

         this.setErrorFocus(state);
         this.scrollToError(state);

         return isValidToContinue;
     }

     scrollToError = (state) => {
         setTimeout(() => {
             var elem = document.querySelector('.elementFocus');
             scrollToElement(elem, {
                 offset: -200,
                 duration: 100
             });
             if(elem){
                 elem.focus();
             }
         }, 500);
     }

     setErrorFocus = (state) => {

         if(!state.firstName.isValid){
             state.firstName.hasErrorFocus = true;
         } else {state.firstName.hasErrorFocus = false;}

         if(!state.lastName.isValid){
             state.lastName.hasErrorFocus = true;
         } else {state.lastName.hasErrorFocus = false;}

         if(!state.password.isValid){
             state.password.hasErrorFocus = true;
         } else {state.password.hasErrorFocus = false;}

         if(!state.captcha.isValid){
             state.captcha.hasErrorFocus = true;
         } else {state.captcha.hasErrorFocus = false;}
     }

	 submitForm = (event) => {
        const isValidToContinue = this.handleValidationBeforeFormSubmit(event);
        console.log("isValidToContinue ..........." + isValidToContinue);
        if(!isValidToContinue){
            return;
        }

        this.setState({
            isCreateUserSubmitted:true
        });

		fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/registerAndJoinOrg?captchaAnswer=' + this.state.captcha.value, {
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': this.state.csrfToken
				},
				body: JSON.stringify({
					firstName: this.state.firstName.value,
					lastName: this.state.lastName.value,
					password: this.state.password.value,
					token: this.state.token.value,
                    newsletter: this.state.newsletterSubscription.value,
                    specialEvents: this.state.eventsSubscription.value
				}),
				credentials: 'include'
			})

			.then(response => {
				console.log("response from registerAndJoinOrg " + response);
				if (!response.ok) {
                    
					this.refreshCaptcha();
                    
                    this.setState({
                        isCreateUserSubmitted:false
                    });

					console.log('response from service is ' + response.status);
					console.log("response is not ok " + response.statusText + " with status of " + response.status);
					if (response.status === 400 || response.status === 409) {
						return response.json();
                    }else{
                        throw new Error("Unknown Problem occurred : " + response.statusText);
                    }
				} else if(response.ok)	{
                    console.log("holy cow, it actually worked.  Sending user to confirmation page. ")
                    window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/registrationConfirmationFNPage.jsp";
				}
			})

			.then(json => {
				if (json) {

					this.refreshCaptcha();

					if(json.errorCode === 'CaptchaInvalidException'){
                        var state = this.state;
                        state['captcha'].isValid = false;
                        state['captcha'].message = "Error: Please enter the text in the captcha image.";

                        this.setState({state});
                    }
                    else if(json.errorCode === 'InvalidTokenException'){
                        this.setState({
                            showEnterUserInfoForm: false
                        })
                        window.location.href = process.env.REACT_APP_HOST_API_URL + '/developer/errorRedirect.jsp?errorKey=invalid.token';
                    }

                    else{
    					for (var i = 0; i < json.validationErrors.length; i++) {
    						this.handleAlignErrors(i, json);
    					}
                    }
				}
			})
			.catch(error => {
				console.log('error trying to upgrade personal account : \n', error);
                this.setState({
                    showEnterUserInfoForm: false
                })
                window.location.href = process.env.REACT_APP_HOST_API_URL + '/developer/error.jsp'
				return Promise.reject()
			})
	}


    handleAlignErrors = (location, json) =>{
        var state = this.state;

        var field = json.validationErrors[location].field;
        var errorCode = json.validationErrors[location].errorCode;

        if(field === 'firstName' && errorCode === "Size")	{
            state[field].isValid = false;
            state[field].message = 'Error: Please enter a First Name that has between 1 and 30 characters.';
        }
        else if(field==='lastName' && errorCode === "Size")	{
                state[field].isValid = false;
                state[field].message = 'Error: Please enter a Last Name that has between 1 and 30 characters.';
        }
        else if(field === 'password' && errorCode === "Pattern")	{
            state[field].isValid = false;
            state[field].message = "Error: Please enter a valid password that has between 8 and 24 character and at least one each of the following : lower case letter, upper case letter, a special character and a number";
        }
        else {
            state[field].isValid=false;
            state[field].message="Error:  Please correct the information in this field ";
       }
       this.setState({state});
    }

	render () {
        const audioUrl = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/captcha/audio?v="+Date.now();
		return (
            <Loader loaded={!this.state.isCreateUserSubmitted}>
			<div>
                <FormErrors formErrors={this.state.genericFormLevelProblems} />
				{this.state.showEnterUserInfoForm === true &&
					<div className="col-12" id="userInfoForm">
                        Please register below :
						<form ref={form => (this.registerUserWithJoinCodeForm = form)} onSubmit={this.handleFormSubmit}>
                            <FormGroup
                              controlId="formBasicTextEmail">
                              <ControlLabel>Email <strong className="text-red"> *</strong></ControlLabel>
                              <FormControl
                                name="email"
                                type="text"
                                value={this.state.email.value}
                                maxLength="100"
                                disabled="true"
                                aria-required="true"
                                aria-describedby="email-error"
                              />
                            </FormGroup>
                            <FormGroup
                              controlId="formBasicTextFirstName"
                              validationState={this.getValidationState(this.state.firstName.isValid)}>
                              <ControlLabel>First Name <strong className="text-red"> *</strong></ControlLabel>
                              <FormError id="firstName-error" errorMessage={this.state.firstName.message } />
                              <FormControl
                                name="firstName"
                                type="text"
                                value={this.state.firstName.value}
                                onChange={this.handleInputChange}
                                maxLength="30"
                                aria-required="true"
                                aria-describedby="firstName-error"
                                {...(this.state.firstName.hasErrorFocus) &&
                                  {className:'elementFocus'}
                                }
                              />
                            </FormGroup>
                            <FormGroup
                              controlId="formBasicTextLastName"
                              validationState={this.getValidationState(this.state.lastName.isValid)}>
                              <ControlLabel>Last Name <strong className="text-red"> *</strong></ControlLabel>
                              <FormError id="lastName-error" errorMessage={this.state.lastName.message } />
                              <FormControl
                                name="lastName"
                                type="text"
                                value={this.state.lastName.value}
                                onChange={this.handleInputChange}
                                maxLength="30"
                                aria-required="true"
                                aria-describedby="lastName-error"
                                {...(this.state.lastName.hasErrorFocus) &&
                                  {className:'elementFocus'}
                                }
                              />
                            </FormGroup>
                            <FormGroup
                              controlId="formBasicTextPassword"
                              validationState={this.getValidationState(this.state.password.isValid)}>
                              <ControlLabel>Password <strong className="text-red"> *</strong></ControlLabel>
                              <FormError id="password-error" errorMessage={this.state.password.message} />
                              <FormControl
                                name="password"
                                type="password"
                                value={this.state.password.value}
                                onChange={this.handleInputChange}
                                maxLength="24"
                                aria-required="true"
                                aria-describedby="password-error"
                                {...(this.state.password.hasErrorFocus) &&
                                  {className:'elementFocus'}
                                }
                              />
                              <HelpBlock>8 Characters Minimum</HelpBlock>
                              <HelpBlock>One lower case</HelpBlock>
                              <HelpBlock>One upper case</HelpBlock>
                              <HelpBlock>One special character</HelpBlock>
                              <HelpBlock>One numeric</HelpBlock>
                              <HelpBlock>Must not have 3 or more sequential/ascending/descending characters</HelpBlock>
                            </FormGroup>

                            <br/>
                            <strong>SUBSCRIPTION PREFERENCES </strong>
                            <FormGroup
                              controlId="newsletterSubscriptionPreferences">
                              <br/>
                              <Checkbox inline checked={this.state.newsletterSubscription.value} name="newsletterSubscription" value="newsletterSubscription" onChange={this.handleInputChange}>Send me the latest news and exclusive offers from the FirstNet Developer Program (monthly newsletter, API information and updates, program updates, and alerts)</Checkbox>
                            </FormGroup>

                            <FormGroup
                              controlId="eventsSubscriptionPreferences">
                              <br/>
                              <Checkbox inline checked={this.state.eventsSubscription.value}  name="eventsSubscription" value="eventsSubscription" onChange={this.handleInputChange}>Event notifications for upcoming FirstNet Developer Program, Hackathons, and events such as Developer Summit, DevLab, and other sponsored events)</Checkbox>
                            </FormGroup>
                            <br/>

                            <FormGroup className="help-block" validationState={this.getValidationState(this.state.captcha.isValid)}>
                                <div id="captcha" className="framePanel captchaBgColor">
                                    <span><img id="captchaImage" src={this.state.captcha.image}  alt="captcha" tabIndex="0"/></span>
                                    <a id="captchaRefresh" role="link" onClick={this.refreshCaptcha} aria-label="Click on Refresh Button to get New Captcha"><i class="fas fa-sync-alt"></i></a>
                                    <a id="captchaAudio" role="link" onClick={this.playClip} aria-label="Click on Audio Button to get Captcha"><i class="fa fa-headphones"></i></a>
                                </div>
                                <audio id="audioCaptcha" ref={this.audioCaptcha} >
                                    <source id="audioSrc" ref={this.audioSrc} src={audioUrl} type="audio/wav" />
                                </audio>
                            </FormGroup>

                            <FormGroup className="help-block" validationState={this.getValidationState(this.state.captcha.isValid)}>
                                <label htmlFor="text_captcha">Enter text seen in above image here <strong className="text-red"> *</strong></label>
                                <FormError id="captcha-error" errorMessage={this.state.captcha.message} />
                                <FormControl id="text_captcha" name="captcha" type="text"
                                value={this.state.captcha.answer}
                                onChange={this.handleInputChange}
                                maxLength="100"
                                aria-required="true"
                                aria-describedby="captcha-error"
                                {...(this.state.captcha.hasErrorFocus) &&
                                  {className:'elementFocus'}
                                }
                                />
                            </FormGroup>
                            <hr/>
                            <FormGroup>
                                <strong>TERMS & CONDITIONS</strong>
                                <div>
                                <strong>NOTE:</strong>
                                By clicking Create Account button below, you agree to the &nbsp;
                                <a href="/firstnet/firstnet-developer-program-terms-and-condition" target="_blank">FirstNet Developer Terms and Conditions</a>.
                                </div>
                            </FormGroup>
                            <hr/>
                            <FormGroup>
                              <div className="row">
                                <div className="col-6">
                                  <input type="submit" className="button primary light-bg variableWidth" value="Create Account" />
                                </div>
                              </div>
                            </FormGroup>
						</form>
					</div>
				}
			</div>
        </Loader>
		)
	}
}

export default RegisterUserWithJoinCode;



// WEBPACK FOOTER //
// ./src/registration/RegisterUserWithJoinCode.js